module.exports = __webpack_public_path__ + "img/瑞安市公安局.de308c9d.png";